import React, { useState } from "react";
import { useModal } from '@/hooks/useModal';
import LegalContentModal from "@/design-system/Molecules/LegalContentModal";
import { PRIVACY_POLICY_CONTENT } from '../../../../constants/legalContent';
import { TERMS_OF_SERVICE_CONTENT } from "@/constants/legalContent";
import type { LegalLinksType } from "../Footer.types";

interface LegalLinksProps {
    legalLinks: LegalLinksType;
    className?: string;
}

const LegalLinks: React.FC<LegalLinksProps> = ({ legalLinks, className = "" }) => {
    const { isOpen: isPrivacyModalOpen, openModal: openPrivacyModal, closeModal: closePrivacyModal } = useModal();
    const [contentState, setContentState] = useState("");

    const hasLinks = legalLinks?.privacyPolicy || legalLinks?.termsOfService;
    if (!hasLinks) return null;

    const handleOpenModal = (content: string) => (e: React.MouseEvent) => {
        e.preventDefault();
        setContentState(content)
        openPrivacyModal();

    };
    return (
        <>
            <div className={`flex space-x-6 text-sm ${className}`}>
                {legalLinks.privacyPolicy && (
                    <button
                        onClick={handleOpenModal("privacyPolicy")}
                        className="text-white hover:text-gray-300 underline transition-colors duration-200 bg-transparent border-none cursor-pointer"
                    >
                        Privacy Policy
                    </button>
                )}
                {legalLinks.termsOfService && (
                    <button
                        onClick={handleOpenModal("termsOfService")}
                        className="text-white hover:text-gray-300 underline transition-colors duration-200 bg-transparent border-none cursor-pointer"
                    >
                        Terms of Service
                    </button>
                )}
            </div>

            <LegalContentModal
                isOpen={isPrivacyModalOpen}
                onClose={closePrivacyModal}
                content={contentState === "termsOfService" ? TERMS_OF_SERVICE_CONTENT : PRIVACY_POLICY_CONTENT}
            />
        </>
    );
};

export default LegalLinks;
